__turbopack_context__.v({
  "articles": "EncyclopediaSubCategory-module-scss-module__unkRsq__articles",
});
